import { jsx } from "react/jsx-runtime";
import classnames from "classnames";
import * as React from "react";
const TldrawUiButton = React.forwardRef(
  function TldrawUiButton2({ children, type, isActive, ...props }, ref) {
    return /* @__PURE__ */ jsx(
      "button",
      {
        ref,
        type: "button",
        draggable: false,
        "data-isactive": isActive,
        ...props,
        className: classnames("tlui-button", `tlui-button__${type}`, props.className),
        children
      }
    );
  }
);
export {
  TldrawUiButton
};
//# sourceMappingURL=TldrawUiButton.mjs.map
